module.exports = __webpack_public_path__ + "static/media/36.641c5b41.svg";